<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="isLoading"
      :items="itemList"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td class="text-xs-center">
          {{ props.item.log_event_name }}
        </td>
        <td class="text-xs-center">{{ props.item.log_event_username }}</td>
        <td class="text-xs-center">{{ props.item.log_event_action }}</td>
        <td class="text-xs-center">
          {{ props.item.log_event_data }}
        </td>
        <td class="text-xs-center">
          {{ moment(props.item.create_at).format("MMMM Do YYYY, HH:mm:ss") }}
        </td>
      </template>

      <template slot="no-data">
        <div v-if="itemList.length == 0 && isLoading != 'black'">
          No data available
        </div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ isLoading == "black" ? "Loading data ..." : isLoading }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["itemList", "isLoading"],
  data: () => ({
    disable_popular: false,
    pagination: {
      rowsPerPage: 10,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Type",
        align: "center",
        value: "store_province_name",
        sortable: false,
      },
      {
        text: "First/Last name",
        align: "center",
        value: "store_name_th",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "store_name_en",
        sortable: false,
      },
      {
        text: "Store name",
        align: "center",
        value: "store_address_th",
        sortable: false,
      },
      {
        text: "Date/Time",
        align: "center",
        value: "store_address_en",
        sortable: false,
      },
    ],
  }),
  components: {},
  computed: {
    pages() {
      if (this.length != 0) {
        this.pagination.totalItems = this.itemList.length;
      }
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {},
  created() {},
  methods: {
    moment,
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}
.view-detail-btn {
  font-size: 13px;
  outline: none;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>


